import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { DataGrid } from '@/components';
import { useDataGridColumns } from '@/components/DataGrid/hooks/useDataGridCols';
import {
  DataGridColSettings,
  mergeColumnSettings,
} from '@/components/DataGrid/utils';
import { LocalStoragePrefix } from '@/constants';
import { useBuildingInspectionContext } from '@/pages/Tools/BuildingInspection/BuildingInspectionContext';
import { visitNotesDataGridColsReduced } from '@/pages/Tools/BuildingInspection/dummy_data/dummy_visit_notes';
import { useUserStore } from '@/store';
import { getLocalStorageItem } from '@/utils';

export const VisitNotesDataGrid = () => {
  const { user } = useUserStore();
  const { visitNotes } = useBuildingInspectionContext();
  const { inspectionId } = useParams();
  const [columnSettings, setColumnSettings] = useState<DataGridColSettings[]>(
    () => {
      const savedSettings = getLocalStorageItem({
        key: String(user?._id),
        prefix: `visit-notes-list-${LocalStoragePrefix.TableSetting}`,
        shouldParse: true,
      });

      if (!savedSettings) {
        return visitNotesDataGridColsReduced;
      }

      return mergeColumnSettings(visitNotesDataGridColsReduced, savedSettings);
    },
  );

  const columns = useDataGridColumns({
    type: 'inspectionVisitNotes',
    onDelete: (e) => e,
    onEdit: (e) => e,
    columnSettings,
  }).map((column) => ({
    ...column,
    renderCell: (params: any) => {
      return column.renderCell ? column.renderCell(params) : params.value;
    },
  }));

  const fetchData = () => {
    return Promise.resolve({
      rows: visitNotes.filter((item) => item.inspection_id === inspectionId),
    });
  };
  return (
    <DataGrid
      hideFilter
      hideFooterPagination
      hideFooter
      key="inspectionVisitNotes"
      name="visit-notes-list"
      columnSettings={columnSettings}
      setColumnSettings={setColumnSettings}
      columns={columns}
      disableMultipleColumnsSorting={true}
      fetchData={fetchData}
      disableRowSelectionOnClick
      autoPageSize={false}
      sx={{ maxHeight: '300px' }}
      slots={{ toolbar: null }}
      rows={visitNotes.filter((item) => item.inspection_id === inspectionId)}
    />
  );
};
